/**
 * Platform-only superadmin role — created by bootstrapPlatform.
 * Never shown in assignment UI or RBAC matrix; cannot be assigned via createUser/updateUser.
 */
export const SUPERADMIN_ROLE_ID = 'superadmin';

export function isSuperadminRole(roleId) {
  return roleId === SUPERADMIN_ROLE_ID;
}

/** Exclude superadmin and roles marked assignable: false from pickers and RBAC UI. */
export function filterAssignableRoles(roles) {
  if (!roles) return roles;

  const isExcluded = (roleId, role) =>
    isSuperadminRole(roleId) || role?.assignable === false;

  if (Array.isArray(roles)) {
    return roles.filter((role) => !isExcluded(role.id ?? role, role));
  }
  return Object.fromEntries(
    Object.entries(roles).filter(([roleId, role]) => !isExcluded(roleId, role))
  );
}
